import { TreinamentoFuncionarioData } from "../../../../rh/domain/models/treinamento_funcionario_data";
import { IGetAllTreinamentoFuncionarioTercDataUseCase } from "../../../presentation/useCases/read/get_all_treinamento_funcionario_terc_data_use_case";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";


export class GetAllTreinamentoFuncionarioTercDataUseCase implements IGetAllTreinamentoFuncionarioTercDataUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) { }

  async getAllTreinamentoFuncionarioTercData(): Promise<TreinamentoFuncionarioData[]> {
    return await this.repository.getAllTreinamentoFuncionarioTercData();
  }
}
